<!-- autor chenhao 2024.11.13 -->
<template>
  <a-card style="margin-bottom: 20px;">
    <template #title>
      <p>{{ props.item.affiliate?.name || '-' }} 
        <span style="font-size: 14px;font-weight: normal; margin-left: 20px;"><span class="label">Status：</span><a-badge :status="props.item.status === 'active' ? 'success' : 'error'" />{{ props.item.status }}</span>
        <span style="font-size: 14px;font-weight: normal; margin-left: 20px;"><span class="label">Traffic Allocation：</span>{{ props.item.percent ?? 0 }}%</span>
      </p>
    </template>
    <template #extra>
      <span><span class="label">Last update time:</span> {{ formatData(props.item.updateTime) }} by<a-button
        style="padding-left: 5px;"
        type="link"
        @click="onShowLogModal"
      >{{ props.item.updateEditor?.name || '-' }}</a-button></span>
      <a-button
        type="link"
        style="margin-left: 20px;"
        :disabled="!allowAdd"
        @click="onEdit"
      >
        Edit
      </a-button>
      <a-button
        type="link"
        style="margin-left: 20px;"
        @click="onFold"
      >
        {{ props.item.flod ? 'Fold' : 'Unfold' }}
        <DownOutlined
          v-if="!props.item.flod"
          style="margin-left: 5px;"
        />
        <UpOutlined
          v-else
          style="margin-left: 5px;"
        />
      </a-button>
    </template>
    <a-row v-if="!props.item.flod">
      <a-col :span="12">
        <p><span class="label">Commissions overview：</span>{{ props.item.commissionsOverview }}</p>
      </a-col>
      <a-col :span="12">
        <p><span class="label">Note：</span>{{ props.item.note }}</p>
      </a-col>
    </a-row>
    <div
      v-if="props.item.flod"
      class="affiliate-info"
    >
      <a-row :gutter="24">
        <a-col
          :span="8"
        >
          Affiliate: <em>{{ props.item.affiliate?.name || '-' }}</em>
        </a-col>
        <a-col
          :span="8"
        >
          Affiliate PID: <em>{{ props.item.affiliate?.pid || '-' }}</em>
        </a-col>
        <a-col
          :span="8"
        >
          Create Time:
          <em>{{
            props.item.createTime
              ? moment(props.item.createTime).format('YYYY-MM-DD HH:mm:ss')
              : '-'
          }}</em>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="24" class="converter-info-col">
          Converter Info:
          <em class="text-wrap">{{ props.item.converterInfo || '-' }}</em>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col
          :span="8"
        >
          Affiliate MID: <em>{{ props.item.affiliateMid || '-' }}</em>
        </a-col>
        <a-col
          :span="8"
        >
          Affiliate Region:
          <em>{{ props.item.affiliateRegion?.name || '-' }}</em>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col
          :span="24"
        >
          Note: <em>{{ props.item.note || 'None' }}</em>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="24">
          KOL rule:
          <em>{{ kolRuleText }}</em>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8">
          Affiliate Threshold:
          <em>{{ salesThreshold?.scopeEnabled ? 'Yes' : 'No' }}</em>
        </a-col>
        <template v-if="salesThreshold?.scopeEnabled">
          <a-col :span="8">
            Monthly Limit:
            <em>{{ salesThreshold?.monthlyLimit != null ? `$${salesThreshold.monthlyLimit}` : '-' }}</em>
          </a-col>
          <a-col :span="8">
            Daily Limit:
            <em>{{ salesThreshold?.dailyLimit != null ? `$${salesThreshold.dailyLimit}` : '-' }}</em>
          </a-col>
        </template>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="24">
          Influencer Threshold:
          <em>{{ salesThreshold?.influencerEnabled ? 'Yes' : 'No' }}</em>
        </a-col>
      </a-row>
      <a-row
        v-if="salesThreshold?.influencerEnabled"
        :gutter="24"
      >
        <a-col :span="24">
          <a-table
            class="influencer-threshold-table"
            size="small"
            :pagination="false"
            :columns="influencerThresholdColumns"
            :data-source="influencerThresholdList"
            row-key="influencerId"
          >
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'influencerName'">
                {{ record.influencerName || record.userName || record.name || record.influencerId || '-' }}
              </template>
              <template v-else-if="column.key === 'dailyLimit'">
                {{ formatLimitAmount(record.dailyLimit) }}
              </template>
              <template v-else-if="column.key === 'monthlyLimit'">
                {{ formatLimitAmount(record.monthlyLimit) }}
              </template>
            </template>
          </a-table>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col
          :span="24"
        >
          Commission Overview:
          <em>{{ props.item.commissionsOverview || '-' }}</em>
        </a-col>
      </a-row>
    </div>
    <CommissionDetail
      v-if="props.item.flod"
      :commission-list="props.item.commissions"
    />
  </a-card>
</template>

<script setup>
import {
DownOutlined,
UpOutlined
} from '@ant-design/icons-vue'
import { computed } from 'vue'

import moment from 'moment';

import CommissionDetail from '../../components/commissionDetail.vue'

const props = defineProps({
  item: { type: Object, default: undefined },
  allowAdd: { type: Boolean, default: false },
  id: { type: String, default: undefined },
  onEdit: { type: Function, default: undefined },
  onFlod: { type: Function, default: undefined },
  onShowLogModal: { type: Function, default: undefined },
})

const salesThreshold = computed(() => {
  const raw = props.item && props.item.salesThreshold
  if (!raw || typeof raw !== 'object') {
    return {
      scopeEnabled: false,
      influencerEnabled: false,
      dailyLimit: null,
      monthlyLimit: null,
      items: [],
    }
  }
  return {
    scopeEnabled: !!raw.scopeEnabled,
    influencerEnabled: !!raw.influencerEnabled,
    dailyLimit: raw.dailyLimit ?? null,
    monthlyLimit: raw.monthlyLimit ?? null,
    items: Array.isArray(raw.items) ? raw.items : [],
  }
})

const kolRuleText = computed(() => {
  const item = props.item
  if (!item) return '-'
  if (!item.kolRule) return 'No'
  const mode = String(item.kolRuleMode || item.ruleMode || '').toLowerCase()
  const rawList =
    mode === 'blacklist' ? item.kolBlackList : item.kolWhiteList
  const list = Array.isArray(rawList) ? rawList : []
  const names = list
    .map((kol) => {
      if (kol == null || typeof kol !== 'object') return ''
      return kol.name || kol.userName || ''
    })
    .filter(Boolean)
  const modeLabel =
    mode === 'blacklist' ? 'blackList' : mode === 'whitelist' ? 'whiteList' : mode
  if (names.length) {
    return `Yes (${modeLabel || 'list'}: ${names.join(', ')})`
  }
  return modeLabel ? `Yes (${modeLabel})` : 'Yes'
})

const influencerThresholdColumns = [
  { title: 'Influencer', dataIndex: 'influencerName', key: 'influencerName' },
  { title: 'DailyLimit', dataIndex: 'dailyLimit', key: 'dailyLimit' },
  { title: 'MonthlyLimit', dataIndex: 'monthlyLimit', key: 'monthlyLimit' },
]

const influencerThresholdList = computed(() => salesThreshold.value.items || [])

function formatLimitAmount(value) {
  if (value == null || value === '') return '-'
  const num = Number(value)
  if (Number.isNaN(num)) return String(value)
  return `$ ${num.toFixed(2)}`
}

const formatData = (time) => {
  if (!time) return '-'
  return moment(time).format('YYYY-MM-DD HH:mm:ss');
}

const onEdit = () => {
  props.onEdit();
}

const onFold =() => {
  props.onFlod();
}

const onShowLogModal = () => {
  props.onShowLogModal();
}

</script>

<style lang="less" scoped>
.affiliate-info {
margin: 20px 0;
color: #999;
:deep(.ant-row) {
  margin-top: 20px;
}
em {
  color: #000;
  font-style: normal;
}
.converter-info-col {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}
.text-wrap {
  display: block;
  max-width: 100%;
  word-break: break-all;
  overflow-wrap: anywhere;
  white-space: normal;
}
}
.label {
color: #999;
}
.influencer-threshold-table {
  margin-top: 12px;
  max-width: 960px;
  :deep(.ant-table) {
    background: #fff;
  }
}
</style>